// BL598 Phase 2 — `grid get <noun>` (kubectl-noun pattern).
//
// Read verbs follow kubectl semantics: a `get` subject over plural nouns
// (`grids`, `entities`, `spaces`). Replaces the deleted top-level `list` verb.

import { Command } from 'commander';
import { getGridsCommand } from './grids.js';
import { getEntitiesCommand } from './entities.js';
import { getSpacesCommand } from './spaces.js';

export const getCommand = new Command('get')
  .description('List grids, entities, or spaces')
  .addCommand(getGridsCommand)
  .addCommand(getEntitiesCommand)
  .addCommand(getSpacesCommand);
